const certImages = [
    {
        id:1,
        src:"Images/certificate-1.jpg",
        alt:"certificte-1"

    },
    {
        id:2,
        src:"Images/certificate-2.png",
        alt:"certificte-1"

    },
    {
        id:3,
        src:"Images/certificate-3.png",
        alt:"certificte-1"

    },
    {
        id:4,
        src:"Images/certificate-4.jpg",
        alt:"certificte-1"

    },
    {
        id:5,
        src:"Images/certificate-5.jpg",
        alt:"certificte-1"

    },
    {
        id:6,
        src:"Images/certificate-6.jpg",
        alt:"certificte-1"

    },
    {
        id:7,
        src:"Images/certificate-7.jpg",
        alt:"certificte-1"

    },
    {
        id:8,
        src:"Images/certificate-8.jpg",
        alt:"certificte-1"

    },
    {
        id:9,
        src:"Images/certificate-9.png",
        alt:"certificte-1"

    }
];

export default certImages;


